import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
} from '@angular/core';
import { AutoCompleteItem } from '../auto-complete-item';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { fetchEventBulbblePath } from '../../utils/fetch-event-bubble-tree';

@Component({
  selector: 'ad-autocomplete',
  templateUrl: './ad-autocomplete.component.html',
  styleUrls: ['./ad-autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AdAutocompleteComponent),
      multi: true,
    },
  ],
})
export class AdAutocompleteComponent
  implements OnInit, ControlValueAccessor, OnDestroy
{
  @Input() items: AutoCompleteItem[];
  @Input() primitiveValue: boolean = false;
  @Output() onChange: EventEmitter<{ item: AutoCompleteItem; input: string }> =
    new EventEmitter();
  @Output() onInputFocus: EventEmitter<Event> = new EventEmitter();
  @Output() onInputBlur: EventEmitter<Event> = new EventEmitter();
  @Output() onInputKeyUp: EventEmitter<Event> = new EventEmitter();
  @Input() popupWidth: string = '100%';
  @Input() popupHeiht: string = 'auto';
  @Input() disabled: boolean = false;
  @Input() openOnFocus: boolean = false;
  globalClickCancler: any;

  showPopup: boolean = false;
  _filterValue: string = '';
  get filterValue() {
    return this._filterValue;
  }

  set filterValue(value: string) {
    this._filterValue = value;
    this.inputValueChange();
    this.valueOnChange(value);
    this.show();
  }
  _selectedItem: AutoCompleteItem;

  set selectedItem(item: AutoCompleteItem) {
    this.valueOnChange(item.text);
    this._selectedItem = item;
  }
  get selectedItem() {
    return this._selectedItem;
  }
  _tempSelectedItem: AutoCompleteItem;

  valueOnChange = (v: any) => {};
  valueOnTouch = () => {};
  writeValue(obj: any): void {
    // if (this.primitiveValue) {
    //   let selectedItem = this.items.find(item => item.value == obj);
    //   if (selectedItem) {
    //     this._selectedItem = selectedItem;
    //   }
    // } else {
    //   let selectedItem = this.items.find(item => item.value == obj.value);
    //   if (selectedItem) {
    //     this._selectedItem = selectedItem;
    //   }
    // }

    this._filterValue = obj;
  }
  registerOnChange(fn: any): void {
    this.valueOnChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.valueOnTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void {}

  constructor(
    private cd: ChangeDetectorRef,
    private renderer: Renderer2,
    private ngZone: NgZone,
    private el: ElementRef
  ) {}
  ngOnDestroy(): void {
    if (this.globalClickCancler) {
      this.globalClickCancler();
    }
  }

  ngOnInit(): void {
    this.ngZone.runOutsideAngular(() => {
      this.globalClickCancler = this.renderer.listen(
        'document',
        'click',
        (event) => {
          let path = fetchEventBulbblePath(event);
          if (path.indexOf(this.el.nativeElement) === -1) {
            this.hide();
            this.cd.detectChanges();
          }
        }
      );
    });
  }

  show() {
    this.showPopup = true;
  }

  hide() {
    this.showPopup = false;
  }

  upKeyDown(e: KeyboardEvent) {
    if (this.showPopup) {
      this.toggleItem(-1);
      e.preventDefault();
    } else {
      if (this.filterValue.length >= 1) {
        this.show();
      }
    }
  }

  downKeyDown(e: KeyboardEvent) {
    if (this.showPopup) {
      this.toggleItem(1);
      e.preventDefault();
    } else {
      if (this.filterValue.length >= 1) {
        this.show();
      }
    }
  }

  enterKeyDown(e: Event) {
    if (this._tempSelectedItem) {
      this.selectedItem = this._tempSelectedItem;
      this._tempSelectedItem = null;
      this.filterValue = this.selectedItem.text;
      this.onChange.emit({ item: this.selectedItem, input: this.filterValue });
      this.hide();
    }
    e.stopPropagation();
    //e.preventDefault();
  }

  selectByClick(item: AutoCompleteItem) {
    this.selectedItem = item;
    this._tempSelectedItem = null;
    this.filterValue = this.selectedItem.text;
    this.onChange.emit({ item: this.selectedItem, input: this.filterValue });
    this.hide();
  }

  toggleItem(seed: number = 1) {
    let index = -1,
      items = this.getFilteredItems();
    if (this._tempSelectedItem) {
      index = items.indexOf(this._tempSelectedItem);
    }
    if (index == -1) {
      this._tempSelectedItem = items[0];
      return;
    }
    if (seed < 0) {
      if (index > 0) {
        index -= 1;
      } else {
        index = items.length - 1;
      }
    } else if (seed > 0) {
      if (index < items.length - 1) {
        index += 1;
      } else {
        index = 0;
      }
    }
    this._tempSelectedItem = items[index];
  }

  getFilteredItems() {
    let key = this.filterValue.toLocaleLowerCase();
    if (key) {
      return this.items.filter(
        (item) =>
          item.value.toLocaleLowerCase().indexOf(key) != -1 ||
          item.text.toLocaleLowerCase().indexOf(key) != -1
      );
    } else {
      return this.items;
    }
  }

  inputValueChange() {
    if (this._tempSelectedItem) {
      //clear the temporary item when filtered out this temporary item.
      if (this.getFilteredItems().indexOf(this._tempSelectedItem) !== -1) {
        this._tempSelectedItem = null;
      }
    }
  }

  inputBlur(event: Event) {
    setTimeout(() => {
      //this.hide();
      if (this.openOnFocus) {
        this.hide();
      }
      this.onInputBlur.emit(event);
    }, 100);
  }

  inputFocus(event: Event) {
    if ((this.filterValue && !this.showPopup) || this.openOnFocus) {
      this.show();
    }
    this.onInputFocus.emit(event);
  }

  inputKeyup(event: Event) {
    this.onInputKeyUp.emit(event);
  }
}
